import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PageHeader = ({ 
  title, 
  subtitle, 
  fallbackPath = "/dashboard", 
  showBackButton = true,
  children 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(fallbackPath);
  };

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        {showBackButton && (
          <button 
            onClick={handleBack} 
            className="mr-3 p-2 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Back"
          >
            <ArrowLeft className="h-5 w-5 text-gray-600" />
          </button>
        )}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-gray-600">{subtitle}</p>}
        </div>
      </div>
      <div className="flex items-center space-x-3">
        {children}
      </div>
    </div>
  );
};

export default PageHeader;
